export default {
  orderedAssessmentTypeFieldGroups: (state) => {
    return [...state.assessmentTypeFieldGroups]
      .sort((a, b) => a.order - b.order);
  },

  sortedAssessmentTypes: (state) => {
    return [...state.assessmentTypes]
      .sort((a, b) => a.assessmentTypeName.localeCompare(b.assessmentTypeName));
  },
};
